module.exports = __webpack_public_path__ + "img/location_black.b8e27f9a.svg";